








import Vue from 'vue'
import NewsEntity from '@/entities/News'
import NewsListItem from '@/components/News/ListItem'

export default Vue.extend({
  components: {
    NewsListItem
  },
  props: {
    list: {
      type: Array as () => NewsEntity[],
      default: () => []
    }
  },
  methods: {
    loopKey(data: NewsEntity): string {
      return `newsList${data.props.id}`
    }
  }
})
